module.exports = __webpack_public_path__ + "img/desktop.eafa1d20.svg";